import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetActividadesPendientes, IGetTramActividadInfo, IGetTramiteActividades, IGetUsuariosValidos, IGetMisTramites, TramSeguimientoDto } from '../../shared/interfaces/database/tramite';
import { Page, Utils } from 'lib-base';
import { TableLazyLoadEvent } from 'primeng/table';


@Injectable({
  providedIn: 'root'
})
export class TramActividadService {
  private readonly baseUrl = `${environment.apiUrl}/api/tram-actividad`;

  constructor(private readonly http: HttpClient) { }

  getActividadesPendientes(): Observable<IGetActividadesPendientes[]> {
    return this.http.get<IGetActividadesPendientes[]>(`${this.baseUrl}/actividades-pendientes`);
  }

  getActividadInfo(tramActividadId: number): Observable<IGetTramActividadInfo> {
    return this.http.get<IGetTramActividadInfo>(`${this.baseUrl}/info/${tramActividadId}`);
  }

  getTramiteActividades(tramRegistroId: number): Observable<IGetTramiteActividades[]> {
    return this.http.get<IGetTramiteActividades[]>(`${this.baseUrl}/tramite/${tramRegistroId}`);
  }

  getUsuariosValidosParaActividad(tramActividadId: number): Observable<IGetUsuariosValidos[]> {
    return this.http.get<IGetUsuariosValidos[]>(`${this.baseUrl}/usuarios-validos/${tramActividadId}`);
  }

  getMisTramitesByDependencia(tramEstados: string[], tramActividadEstados: string[], event?: TableLazyLoadEvent): Observable<Page<IGetMisTramites>> {
    let params = Utils.getLazyLoadParams(event ?? {});
    return this.http.get<Page<IGetMisTramites>>(`${this.baseUrl}/mis-tramites/dependencia/${tramEstados.join(',')}/${tramActividadEstados.join(',')}`, { params });
  }

  getMisTramites(tramEstados: string[], tramActividadEstados: string[]): Observable<IGetMisTramites[]> {
    return this.http.get<IGetMisTramites[]>(`${this.baseUrl}/mis-tramites/${tramEstados.join(',')}/${tramActividadEstados.join(',')}`);
  }

  finalizarActividad(tramActividadId: number, request?: TramSeguimientoDto, documentos?: File[]): Observable<number> {
    const formData: FormData = new FormData();    
    if (request) {
      if (documentos) {
        documentos.forEach((file, index) => {
          formData.append('documentos', file);
        });
      }
      formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    }

    return this.http.post<number>(`${this.baseUrl}/finalizar/${tramActividadId}`, formData);
  }

  reasignarActividad(tramActividadId: number, usuarioId: number): Observable<string> {
    return this.http.put(`${this.baseUrl}/reasignar/${tramActividadId}/${usuarioId}`, null, { responseType: 'text' });
  }

  reabrirActividad(tramActividadId: number): Observable<string> {
    return this.http.post(`${this.baseUrl}/reabrir/${tramActividadId}`, null, { responseType: 'text' });
  }

  asignacionManualUsuario(tramActividadId: number, usuarioId: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/asignacion-manual/${tramActividadId}/${usuarioId}`, null);
  }
}
